export const ApprovalStatus = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const StatusColorCode = {
  Pending: "orange",
  Approved: "green",
  Rejected: "red",
};

export const ImageAltText = {
  pdfAltText: "PDF ICON",
};

export const ModalTitle = {
  BOND_INFO_DOC: "Bond Info Document",
};

export const ModalWidth = "846px";
